export default "__VITE_ASSET__BZjFv$uV__"